import React, { useEffect, useState } from "react";
import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinnerButton,
  NewButton,
  NewInputLang,
} from "../../components/ui";
import { IoMdAdd } from "react-icons/io";
import { BiEdit } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";

const PaymentVoucherTypes = ({ apiBaseUrl }) => {
  const { t } = useTranslation("settings");
  const [langar, setLangar] = useState(true);
  const [expensesList, setExpenseList] = useState([]);
  const [expenseCode, setExpenseCode] = useState("");
  const [expenseName, setExpenseName] = useState("");
  const [expenseEnName, setExpenseEnName] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedExpenseId, setSelectedExpenseId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingExpenseId, setEditingExpenseId] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } =
    useCurrent();
  const { postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const baseFinanceUrl = (apiBaseUrl || process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
  const buildFinanceUrl = (path) =>
    `${baseFinanceUrl}/${String(path || "").replace(/^\/+/, "")}`;
  const {
    data: expensesResult,
    loading: loadingExpenses,
    refreshHandler: refetchExpenses,
  } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `expenses-types/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { data: expensesCountResult, refreshHandler } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `expenses-types/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { loading: saveloading, putData } = usePut();

  useEffect(() => {
    if (expensesCountResult && !isEditing) {
      setExpenseCode((parseInt(expensesCountResult?.data) + 1).toString());
    }
  }, [expensesCountResult, isEditing]);

  useEffect(() => {
    if (expensesResult?.data) {
      setExpenseList(expensesResult.data);
    }
  }, [expensesResult]);

  const addExpense = () => {
    let errors = {};

    if (!expenseCode) errors.code = "Code Is Required";
    if (langar && !expenseName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !expenseEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const expenseData = {
      code: expenseCode,
      name_ar: expenseName || "-",
      name_en: expenseEnName || "-",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setExpenseCode("");
      setExpenseName("");
      setExpenseEnName("");
      setIsEditing(false);
      setEditingExpenseId(null);
      setError({});
    };

    if (!baseFinanceUrl) return;
    if (!isEditing) {
      postData(
        buildFinanceUrl("expenses-types"),
        expenseData
      ).then(() => {
        refetchExpenses();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        buildFinanceUrl(`expenses-types/${editingExpenseId}`),
        expenseData
      ).then(() => {
        refetchExpenses();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteExpense = (id) => {
    if (!baseFinanceUrl) return;
    deleteItem(buildFinanceUrl(`expenses-types/${id}`)).then(() => {
      refetchExpenses();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!expenseCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteExpense(selectedExpenseId)}
            loading={delloading}
            msg={t("expense.expensedel")}
          />
          <div className="flex justify-start w-full items-end gap-2">
            <div className="w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("expense.expensecode")}
                value={expenseCode}
                onChange={(e) => setExpenseCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-80 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("expense.expensenameplaceholder")}
                label={t("expense.expensename")}
                value={langar ? expenseName : expenseEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setExpenseName(value);
                  } else {
                    setExpenseEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>

            <div className="group">
              <NewButton onClick={addExpense}>
                {loading || saveloading ? (
                  <MwSpinnerButton />
                ) : isEditing ? (
                  t("general.update")
                ) : (
                  <>
                    <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                    <p className="">{t("general.Add")}</p>
                  </>
                )}
              </NewButton>
            </div>
          </div>

          {loadingExpenses && expensesList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              <MwSpinnerButton />
            </div>
          ) : expensesList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-0 text-center">#</div>
                  <div className="w-52 text-center">
                    {t("expense.expensecode")}
                  </div>
                  <div className="flex-1 text-center">
                    {t("expense.expensename")}
                  </div>
                  <div className="flex-1 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {expensesList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-1 text-center">{index + 1}</div>
                      <div className="w-52 text-center">{item?.code}</div>
                      <div className=" flex-1 text-center">
                        {currentLangId === "ar" ? item?.name_ar : item?.name_en}
                      </div>
                      <div className=" flex me-4 justify-end items-center flex-1 text-end gap-1">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingExpenseId(item.id);
                            setExpenseCode(item.code);
                            setExpenseEnName(item.name_en);
                            setExpenseName(item.name_ar);
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <BiEdit size={16} />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedExpenseId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <RiDeleteBinLine size={16} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
            <div className=" h-[calc(100vh-230px)] ">
              <SettingsEmptyState msg={t("expense.validate")} />
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default PaymentVoucherTypes;
